<ng-template #sendCrmAgenda>
  <div class="crm-modal-container">
    <form #sendCrmAgenda="ngForm" [class.submitted]="sendCrmAgenda.submitted" (ngSubmit)="submit(sendCrmAgenda)" class="w-100 send-crm-agenda-form" novalidate>
      <div class="crm-modal-header"><span class="header-app">{{ 'CRM.SONAR' | translate }}</span><span class="header-modal-title">{{ 'CRM.SEND_CRM_AGENDA.SEND_CRM_AGENDA' | translate }}</span></div>
      <div class="crm-modal-body">
        <div class="user-domains">
          <div class="instructions">{{ 'CRM.SEND_CRM_AGENDA.INSTRUCTIONS' | translate }}</div>
          <div class="options">
            <div *ngIf="userDomains.length === 0">{{ 'CRM.SEND_CRM_AGENDA.NO_USER_DOMAINS' | translate }}</div>
            <div *ngFor="let domain of userDomains">
              <input [(ngModel)]="selectedDomainId" class="form-check-input" type="radio" name="domain" [id]="domain.shortName" [value]="domain.id" [attr.disabled]="!domainTotals[domain.name] || null">
              <label class="form-check-label" [for]="domain.shortName">
                <span class="domain-name">{{domain.name}}</span><span class="domain-total">({{domainTotals[domain.name] || 0}})</span>
              </label>
            </div>
          </div>
          <div class="note"><span class="bold">{{ 'CRM.SEND_CRM_AGENDA.NOTE' | translate}}</span> {{ 'CRM.SEND_CRM_AGENDA.NOTE_CONTENT' | translate }}</div>
        </div>
        <div class="agenda-schedules">
          <div class="agenda-schedules-title">{{ 'CRM.SEND_CRM_AGENDA.DOMAIN_AGENDA_SCHEDULES' | translate }}</div>
          <ul class="agenda-schedules-items">
            <li *ngFor="let item of formatAgenda()">{{item}}</li>
          </ul>
        </div>
      </div>
      <div class="modal-footer">
        <button class="btn btn-default" (click)="close()">{{"GENERICS.CANCEL" | translate}}</button>
        <button class="btn btn-primary" (click)="submit(addCrmForm)" [disabled]="!selectedDomainId">{{"CRM.SEND_CRM_AGENDA.SEND" | translate}}</button>
      </div>
    </form>
  </div>
</ng-template>
